import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { Compliance } from "@smeetz/compliance-common";
import { IComplianceState } from "@/interfaces/store/ICompliance";
@Module({ dynamic: true, namespaced: true, store, name: "Compliance" })
class ComplianceMod extends VuexModule implements IComplianceState {
  public compliance: Compliance | null = null;
  public transactionNumber = 1;
  public complianceStatus = {
    packageInit: true,
    efrConnection: true,
    fdmConnection: true,
  };

  @Mutation
  setComplianceObj(data: { compliance: Compliance }) {
    const { compliance } = data;
    this.compliance = compliance;
  }

  @Mutation
  increaseTransactionNumber() {
    this.transactionNumber++;
  }

  @Mutation
  resetTransactionNumber() {
    this.transactionNumber = 1;
  }

  @Mutation
  setComplianceStatus(data: {
    packageInit?: boolean;
    efrConnection?: boolean;
    fdmConnection?: boolean;
  }) {
    if (data.packageInit !== undefined) {
      this.complianceStatus.packageInit = data.packageInit;
    }
    if (data.efrConnection !== undefined) {
      this.complianceStatus.efrConnection = data.efrConnection;
    }
    if (data.fdmConnection !== undefined) {
      this.complianceStatus.fdmConnection = data.fdmConnection;
    }
  }

  /**
   * Resotres compliance module fields saved in localstorage
   */
  @Mutation
  restore(complianceFields: Partial<IComplianceState>) {
    const { transactionNumber } = complianceFields;
    if (transactionNumber) {
      this.transactionNumber = transactionNumber;
    }
  }
}

const ComplianceModule = getModule(ComplianceMod);
export default ComplianceModule;
